/* eslint-disable eqeqeq */
import { FormRow } from 'framework/ui/layout';
import { Box } from '@mui/material';
import {
  CountryDropdown,
  CountryBadge,
  BELARUS,
  POLAND,
  ClearAfterUnmountWrapper,
  FormFieldsData,
  useFormContext,
  useInputHelper,
} from 'framework/form';
import { Typography } from '@mui/material';
import {
  EDUCATION_SPECIALIST_ID,
  isSoftwareEngineerOrEducationalSpecialist,
  SOFTWARE_ENGINEER_ID,
  PositionDropdown,
} from 'domain/shared/employee';
import { COMPENSATION_CURRENCY_TYPES } from 'domain/shared/newVacancy';
import { TechnologyDropdown, getTechnologyFilter } from 'domain/shared/career';

const SalaryForkMenu = () => {
  const { data } = useFormContext();
  const { specialization, currency } = data || {};
  const { getRawOnChangeCallback } = useInputHelper({ source: 'specialization' });

  const rawOnChangeCallback = getRawOnChangeCallback() || (() => {});

  const onChangeSpecializationCallback = (newData: FormFieldsData) => {
    const newSpecialization = newData?.specialization;
    if (newSpecialization == SOFTWARE_ENGINEER_ID || newSpecialization == EDUCATION_SPECIALIST_ID) {
      rawOnChangeCallback({
        specialization: newSpecialization,
        technology: '',
      });
    } else {
      rawOnChangeCallback(newData);
    }
  };

  const onChangeCountryCallback = (newData: FormFieldsData) => {
    const newCountry = newData?.country;
    if (newCountry == BELARUS.code) {
      rawOnChangeCallback({
        country: newCountry,
        currency: COMPENSATION_CURRENCY_TYPES.USD,
      });
    } else if (newCountry == POLAND.code) {
      rawOnChangeCallback({
        country: newCountry,
        currency: COMPENSATION_CURRENCY_TYPES.PLN,
      });
    } else {
      rawOnChangeCallback(newData);
    }
  };

  return (
    <Box
      sx={(theme: any) => ({
        [theme.breakpoints.down('sm')]: {
          flexWrap: 'wrap',
          gap: '10px',
        },
        display: 'flex',
        gap: '50px',
        mb: '30px',
        '.floating-label-baseInput': {
          mb: '0px !important',
        },
      })}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          minWidth: '105px',
          '.floating-base-fieldset': {
            borderWidth: '0px !important',
          },
          '.dropdown__clear-indicator': {
            display: 'none',
          },
        }}
      >
        <CountryDropdown
          source="country"
          placeholder=""
          label=""
          options={[BELARUS, POLAND].map(state => ({
            value: state.code,
            label: <CountryBadge country={state.name} />,
          }))}
          onChangeCallback={onChangeCountryCallback}
        />

        <Typography textAlign="center">{currency}</Typography>
      </Box>

      <Box
        sx={{
          width: '100%',
        }}
      >
        <FormRow
          sx={(theme: any) => ({
            [theme.breakpoints.down('md')]: {
              gap: '10px',
            },
          })}
        >
          <PositionDropdown
            source="specialization"
            label="Specialization"
            onChangeCallback={onChangeSpecializationCallback}
          />

          <ClearAfterUnmountWrapper
            isVisible={salaryData => isSoftwareEngineerOrEducationalSpecialist(salaryData.specialization)}
          >
            <TechnologyDropdown
              source="technology"
              label="Technology"
              customReduce={getTechnologyFilter(specialization)}
              deps={[specialization]}
            />
          </ClearAfterUnmountWrapper>
        </FormRow>
      </Box>
    </Box>
  );
};

export default SalaryForkMenu;
